import { render, staticRenderFns } from "./ExpertNei.vue?vue&type=template&id=74fa09c8&scoped=true"
import script from "./ExpertNei.vue?vue&type=script&lang=js"
export * from "./ExpertNei.vue?vue&type=script&lang=js"
import style0 from "./ExpertNei.vue?vue&type=style&index=0&id=74fa09c8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74fa09c8",
  null
  
)

export default component.exports